import FancyBox from './FancyBox';

export default function ImageLink({
	src,
	thumbSrc,
	icon = 'fas fa-expand',
	iconPadding = 'tw-p-3',
	twHeight = '',
	defaultSrc = '/default.jpg',
	galleryID,
	rounded = '',
	classes = '',
	alt = 'work',
	loaded = true,
	setLoaded = () => null,
}) {
	if (!src) setLoaded(true);
	return (
		<div
			className={`${twHeight} tw-relative tw-shadow tw-group tw-cursor-pointer ${rounded} ${classes}`}>
			<div
				className={`tw-absolute tw-h-full tw-w-full tw-animate-pulse tw-bg-slate-200 tw-z-[-1] ${rounded}`}></div>
			<FancyBox options={{ infinite: false }}>
				<div
					className='tw-w-full tw-h-full'
					data-src={src || defaultSrc}
					data-fancybox={`gallery-${galleryID}`}>
					<img
						src={thumbSrc || defaultSrc}
						alt={alt}
						className={`tw-w-full tw-h-full tw-object-cover tw-object-center ${rounded} ${
							!loaded && 'tw-hidden'
						}`}
					/>
				</div>
			</FancyBox>
			<div
				className={`tw-absolute tw-w-full tw-h-full tw-top-0 tw-flex tw-items-end tw-justify-end tw-text-white tw-leading-none tw-pointer-events-none tw-bg-black/20 group-hover:tw-bg-black/10 tw-transition-all ${iconPadding} ${rounded}`}>
				<i className={`${icon} fa-lg group-hover:tw-scale-125 tw-transition-all`}></i>
			</div>
		</div>
	);
}
